import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  inventarioPorBodega, agregarStock, descontarStock, ajustarStock,
  type OperacionStock, type AjusteStock,
} from '../lib/api/inventario';
import { qk, invalidarStock } from './keys';

export function useInventario(bodegaId: string | undefined) {
  return useQuery({
    queryKey: [...qk.inventario, bodegaId],
    queryFn: () => inventarioPorBodega(bodegaId as string),
    enabled: !!bodegaId,
  });
}

export function useAgregarStock() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (op: OperacionStock) => agregarStock(op),
    onSuccess: () => invalidarStock(qc),
  });
}

export function useDescontarStock() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (op: OperacionStock) => descontarStock(op),
    onSuccess: () => invalidarStock(qc),
  });
}

export function useAjustarStock() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (op: AjusteStock) => ajustarStock(op),
    onSuccess: () => invalidarStock(qc),
  });
}
